import loadApp from '~/services/bootstrap';
import App from './app.vue';

loadApp('#reverse-mortgage-app', App);
